module.exports = __webpack_public_path__ + "img/ics_f_thumb-bad.d0c8f2ea.svg";